// extracted by mini-css-extract-plugin
export default {"button":"Comments_button__81SDg","highlight":"Comments_highlight__xRCyJ"};